import { env } from "@/lib/env";

type MetaEventPayload = Record<string, string | number | boolean>;
export const META_PIXEL_SRC = "https://connect.facebook.net/en_US/fbevents.js";

declare global {
	interface Window {
		fbq?: (
			action: "track" | "trackCustom" | "init",
			eventOrPixel: string,
			payload?: MetaEventPayload,
		) => void;
		__lovepageMetaPixelsInitialized?: Record<string, true>;
	}
}

export function getMetaPixelIds(raw = env.NEXT_PUBLIC_META_PIXEL_IDS): string[] {
	if (!raw) return [];
	return raw
		.split(",")
		.map((id) => id.trim())
		.filter(Boolean);
}

export function createMetaPixelScript(pixelIds = getMetaPixelIds()): string {
	if (!pixelIds.length) return "";

	const initCode = pixelIds
		.map(
			(id) =>
				`if (!initialized['${id}']) { fbq('init', '${id}'); initialized['${id}'] = true; }`,
		)
		.join("\n");
	return `!function(w){
if(!w.fbq){var n=w.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!w._fbq)w._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];}
var initialized=w.__lovepageMetaPixelsInitialized=w.__lovepageMetaPixelsInitialized||{};
${initCode}
fbq('track','PageView');
}(window);`;
}

export function trackMetaBrowserEvent(
	eventName: string,
	payload?: MetaEventPayload,
): void {
	if (typeof window === "undefined" || typeof window.fbq !== "function") return;
	if (payload) {
		window.fbq("track", eventName, payload);
		return;
	}
	window.fbq("track", eventName);
}
